mod.modules.define("ResearchPage", function(fn) {

	var $window = null;
	var $sections = null;
	var pageHeaderHeight = 0;
	var pageFooterHeight = 0;
	var _lastSymbol = "";
	var _lastListId = "";
	var _defaultSection = "library";
	var _featuredListHeight = 0;

	fn.prototype.init = function() {
		var self = this;

		// Cache
		$window = $(window);
		$sections = this.el.find("div.sections");
		pageHeaderHeight = this.el.find("div.mod_site_header").outerHeight();
		pageFooterHeight = $("div.mod_site_footer").outerHeight();

		// Setup the initial hash and direct the user to the correct section
		this.initHash();

		// Add some listeners to the window
		$window
			.on("hashchange", $.proxy(this.action_hashChange, this))
			// I know this looks weird, but it's here on purpose
			// We don't want to pass any arguments to the handler
			.on("resize", $.throttle(1, function() { self.resizeActiveSection($sections.find("div.section.active")); }));
	};

	fn.prototype.action_hashChange = function() {
		var symbol = $.bbq.getState("sym");
		var listId = $.bbq.getState("list");
		var section = $.bbq.getState("sec");

		// Tell everyone there's a new symbol
		if (symbol && symbol !== _lastSymbol) {
			_lastSymbol = symbol;
			mod.observer.trigger("symbol - changed", { symbol: symbol, listId: listId }, this.reloadDequeue);
		}

		// Tell everyone there's a new list
		if (listId != _lastListId) {
			_lastListId = listId;
			mod.observer.trigger("list changed", listId, this.reloadDequeue);
		}

		// Switch to the new section
		if (section && section !== $sections.attr("data-active")) {
			mod.sections.switchTo(section, {
				animate: true,
				data: this.getHashContext(_lastSymbol, _lastListId)
			});
		}
	};

	// Set up the hash on page load
	fn.prototype.initHash = function () {
		// If we have "redirectedHashValue" in the cookies, we were redirected because a "hash" querystring was used (see ResearchController.cs)
		// In that case, we need to append the hash to the url;
		var cookieparts = document.cookie.split("; redirectedHashValue=");
		if (cookieparts.length == 2) {
			var redirectedHashValue = cookieparts.pop().split(";").shift();
			window.location.hash = redirectedHashValue;

			// now we delete that cookie
			document.cookie = 'redirectedHashValue=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
		}

		var section = $.bbq.getState("sec");

		if (section && section !== _defaultSection) {
			var data = this.getHashContext();

			mod.sections.switchTo(section, {
				animate: false,
				data: data
			});

			// Update the stored records
			_lastSymbol = data.Symbol;
			_lastListId = data.ListId;
		}
		else if (!section) {
			$.bbq.pushState({ sec: _defaultSection });
		}
	};

	fn.prototype.getActiveSectionName = function() {
		return $sections.attr("data-active");
	};

	fn.prototype.resizeActiveSection = function($activeSection, forceResize) {
		if ($activeSection) {
			var isActiveSection = $activeSection.attr("data-section") === this.getActiveSectionName();

			// Make sure we're given a section and that it's currently the active one
			if (isActiveSection || forceResize) {
				// Flip the height back to auto
				$activeSection.css("height", "");

				var sectionHeight = $activeSection.outerHeight();
				var availableHeight = $window.height() - pageHeaderHeight - pageFooterHeight;
				var sectionsWrapperHeight = this.el.find("div.sections").height();

				var rightHeight = Math.max(availableHeight, sectionsWrapperHeight);

				// Only resize the section if there's room to grow
				if (rightHeight > sectionHeight) {
					$activeSection.height(rightHeight);
				}
			}
		}
	};

	fn.prototype.getHashContext = function(symbol, list) {
		return {
			Symbol: symbol || _lastSymbol || $.bbq.getState("sym"),
			ListId: list || _lastListId || $.bbq.getState("list")
		};
	};

	fn.prototype.observables = {
		"section - loaded": function($el) {
			if ($el.attr("data-section") === this.getActiveSectionName()) {
				$el.addClass("active");
			}

			this.resizeActiveSection($el);
		},
		"section - changed": function($el) {
			var forceResize = $el.hasClass("loading");

			this.resizeActiveSection($el, forceResize);
		}
	};

	fn.prototype.events = {
		"[data-auto-symbol]": {
			"click": function(e, $el) {
				var symbol = $el.attr("data-auto-symbol").toLowerCase();
				$.bbq.pushState({ sym: symbol });
				$.bbq.pushState({ sec: "company" });
			}
		},
		"[data-auto-list]": {
			"click": function(e, $el) {
				var listId = $el.attr("data-auto-list");
				$.bbq.pushState({ list: listId });
			}
		},
		"[data-auto-section]": {
			"click": function(e, $el) {
				var section = $el.attr("data-auto-section").toLowerCase();
				$.bbq.pushState({ sec: section });
			}
		},
		"button[data-action=view-sample-data]": {
			"click": function (e, $el) {
				window.open('../Content/SampleData.pdf');
			
			}
		},
		"#inputPredefinedScreens": {
			"click": function (e, $el) {
				/* TT0290965
				var divspan = $('#featuredLists').parent();
				var groupdiv = $el.parent();
				var wholeSection = $('#widget-com_librarysection');
				var wholeSectionHeight = wholeSection.height();
				var topOffset = divspan.position().top;
				var divspanheight = 0;
				var ul = groupdiv.find('ul.dropdown-menu');
				var ulheight = ul.height();
				_featuredListHeight = ulheight;
				var combinedheight = ulheight + divspanheight;
				
				if (groupdiv.hasClass('open')) {
					
					var currentHeight = divspan.height();
					divspan.css('height', currentHeight - _featuredListHeight);
					console.log("divspanheight: " + divspanheight);
					console.log("ulheight: " + ulheight);
					console.log("combinedheight: " + combinedheight);
					console.log("wholesectionheight: " + wholeSectionHeight);
					console.log("topOffset: " + topOffset);
					wholeSection.css('height', wholeSectionHeight - _featuredListHeight - divspanheight + topOffset);
				} else {
					divspanheight = divspan.height();
					

					console.log("divspanheight: " + divspanheight);
					console.log("ulheight: " + ulheight);
					console.log("combinedheight: " + combinedheight);
					console.log("wholesectionheight: " + wholeSectionHeight);
					console.log("topOffset: " + topOffset);
					divspan.css('height', combinedheight);

					wholeSection.css('height', wholeSectionHeight + _featuredListHeight + divspanheight - topOffset);
					
				}
				*/
			}
		}
	};

});